import { KeyValuePair } from 'common/types/key-value-pair';
import { selectPathCalculationType } from '../paths.slice';
import { useSelector } from 'react-redux';
import { PathTimeCalculationTypes } from '../paths.models';
import { Duration } from 'luxon';

interface PathTimeProps {
  timeCalculationsInSeconds: KeyValuePair<PathTimeCalculationTypes, number>[];
}

const getCalculationsForSelectedCalculation = (
  timeCalculation: KeyValuePair<PathTimeCalculationTypes, number>
) => {
  const seconds = Duration.fromObject({ seconds: timeCalculation.value });
  const days = seconds.as('days');
  const hours = seconds.as('hours');
  const minutes = seconds.as('minutes');

  if (days >= 1) {
    return `${Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(
      days
    )} Days`;
  }
  if (hours >= 1) {
    return `${Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(
      hours
    )} Hours`;
  }
  if (minutes >= 1) {
    return `${Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(
      minutes
    )} Minutes`;
  }
  return `${Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(
    seconds.seconds
  )} Seconds`;
};

export const PathTime = ({ timeCalculationsInSeconds }: PathTimeProps) => {
  const selectedCalculationType = useSelector(selectPathCalculationType);

  const timeCalculation = timeCalculationsInSeconds.find(
    (tc) => tc.key === selectedCalculationType
  )!;
  const calculatedTime = getCalculationsForSelectedCalculation(timeCalculation);
  return <>{calculatedTime} </>;
};
